import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { LanguageService } from '../../shared/services/language.service';
import { DocumentItem } from '../../shared/sdk';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-document-taxes-table',
  templateUrl: './document-taxes-table.component.html',
  styleUrls: ['./document-taxes-table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentTaxesTableComponent implements OnInit {
  @Input() currency: string;
  @Input() inForeignCurrency: boolean;
  @Input() items: DocumentItem[];
  @Input() locale: string;
  @Input() taxes: any[];
  @Input() total: number;

  constructor(
    public languageService: LanguageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {}

  get simple(): boolean {
    return this.taxes.length === 1 && this.taxes[0].base === this.total && !this.inForeignCurrency;
  }

  name(tax: any): Observable<string> {
    let _name: string;
    let name: Observable<string>;

    if (this.simple) {
      if (tax.abbreviation) {
        _name = tax.abbreviation;
      } else {
        const itemWithTax = this.items.find(i => i._documentItemTaxes.length);

        if (itemWithTax) {
          _name = itemWithTax._documentItemTaxes[0].abbreviation;
        }
      }

      if (_name) {
        name = of(_name);
      } else {
        // Tax x%
        name = this.translate.get('document-view-public.document-taxes-table.tax', {
          tax: this.languageService.formatNumber(tax.tax, 2, this.locale)
        });
      }
    } else {
      // Tax x% of y
      name = this.translate.get('document-view-public.document-taxes-table.tax-of-base', {
        tax: tax.tax,
        base: this.languageService.formatCurrency(tax.base, this.currency, this.locale)
      });
    }

    return name;
  }
}
